var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurrencyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6924 35.9393C21.2806 35.9393 25.0001 34.2862 25.0001 32.247C25.0001 30.2078 21.2806 28.5547 16.6924 28.5547C12.1042 28.5547 8.38477 30.2078 8.38477 32.247C8.38477 34.2862 12.1042 35.9393 16.6924 35.9393Z",
    stroke: "#DF7D76",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38477 32.2469V43.3238C8.38477 45.3546 12.0771 47.0161 16.6924 47.0161C21.3078 47.0161 25.0001 45.3546 25.0001 43.3238V32.2469",
    stroke: "#DF7D76",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0001 37.7853C25.0001 39.816 21.3078 41.4776 16.6924 41.4776C12.0771 41.4776 8.38477 39.816 8.38477 37.7853",
    stroke: "#DF7D76",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5076 24.8624C14.3504 23.531 11.8393 22.8872 9.30767 23.0162C4.71076 23.0162 1 24.6777 1 26.7085C1 27.7977 3.5 30.0903 6 30.5903",
    stroke: "#DF7D76",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 41.5903C3 41.0903 1 39.5903 1 37.7855V26.7086",
    stroke: "#DF7D76",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 36.0903C2.93333 35.077 1 33.6637 1 32.0903",
    stroke: "#DF7D76",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2695 10.3969V6.87305",
    stroke: "#DF7D76",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7461 19.7937C26.7461 21.5556 28.3201 22.1429 30.2699 22.1429C32.2197 22.1429 33.7937 22.1429 33.7937 19.7937C33.7937 16.2699 26.7461 16.2699 26.7461 12.7461C26.7461 10.3969 28.3201 10.3969 30.2699 10.3969C32.2197 10.3969 33.7937 11.2895 33.7937 12.7461",
    stroke: "#DF7D76",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.27 22.1428V25.6666",
    stroke: "#DF7D76",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2698 31.5396C38.7031 31.5396 45.5396 24.7031 45.5396 16.2698C45.5396 7.83653 38.7031 1 30.2698 1C21.8365 1 15 7.83653 15 16.2698C15 24.7031 21.8365 31.5396 30.2698 31.5396Z",
    stroke: "#DF7D76",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyIcon);
export default __webpack_public_path__ + "static/media/currency_icon.7961570bf57c7e7ac41c2e010a92ec55.svg";
export { ForwardRef as ReactComponent };